import { render, staticRenderFns } from "./InsertAsterLead.vue?vue&type=template&id=2cf3eac2&"
import script from "./InsertAsterLead.vue?vue&type=script&lang=js&"
export * from "./InsertAsterLead.vue?vue&type=script&lang=js&"
import style0 from "./InsertAsterLead.vue?vue&type=style&index=0&id=2cf3eac2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports